import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
    const location = useLocation();
    const currentPath = location.pathname;

    return (
        <>
            <nav className="custom-navbar navbar navbar-expand-md navbar-dark bg-dark" aria-label="Furni navigation bar">
                <div className="container">
                    <Link className="navbar-brand" to="/">
                        <img src="images/su_LOGO.jpg" class="navbar" alt='logo' style={{ height: "65px", width: "200px" }} />
                    </Link>

                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarsFurni" aria-controls="navbarsFurni" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarsFurni">
                        <ul className="custom-navbar-nav navbar-nav ms-auto mb-2 mb-md-0">
                            <li className={`nav-item ${currentPath === '/' ? 'active' : ''}`}>
                                <Link className="nav-link" to="/">Home</Link>
                            </li>
                            <li className={`nav-item ${currentPath === '/New_arrivals' ? 'active' : ''}`}>
                                <Link className="nav-link" to="/New_arrivals">New Arrivals</Link>
                            </li>
                            <li className="nav-item dropdown custom-dropdown">
                                <span role="button">
                                    <Link to="/shopping" className="nav-link dropdown-toggle">Product</Link>
                                </span>
                                <ul className="dropdown-menu">
                                    <li className="dropdown-submenu">
                                        <span className="dropdown-item dropdown-toggle">Mattress</span>
                                        <ul className="dropdown-menu">
                                            <li><Link className="dropdown-item" to="/spring_mattress">Spring Mattress</Link></li>
                                            <li><Link className="dropdown-item" to="/foam_mattress">Foam Mattress</Link></li>
                                            <li><Link className="dropdown-item" to="/coir_mattress">Coir Mattress</Link></li>
                                        </ul>
                                    </li>
                                    <li className="dropdown-submenu">
                                        <span className="dropdown-item dropdown-toggle">Pillows</span>
                                        <ul className="dropdown-menu">
                                            <li><Link className="dropdown-item" to="/pillows_polyfill">Polyfill</Link></li>
                                        </ul>
                                    </li>
                                    <li className="dropdown-submenu"><Link className="dropdown-item" to="/bed_sheet">Bed Sheet</Link>
                                        {/* <span className="dropdown-item dropdown-toggle">Pillows</span>
                                        <ul className="dropdown-menu">
                                            <li><Link className="dropdown-item" to="/pillows_polyfill">Polyfill</Link></li>
                                        </ul> */}
                                    </li>
                                </ul>
                            </li>
                            <li className={`nav-item ${currentPath === '/about' ? 'active' : ''}`}>
                                <Link className="nav-link" to="/about">About US</Link>
                            </li>
                            <li className={`nav-item ${currentPath === '/blog' ? 'active' : ''}`}>
                                <Link className="nav-link" to="/blog">Blog</Link>
                            </li>
                            <li className={`nav-item ${currentPath === '/contact' ? 'active' : ''}`}>
                                <Link className="nav-link" to="/contact">Contact US</Link>
                            </li>
                        </ul>

                        {/* <ul className="custom-navbar-cta navbar-nav mb-2 mb-md-0 ms-5">
                            <li><Link className="nav-link" to="/profile"><img src="images/user.svg" alt="user" /></Link></li>
                            <li><Link className="nav-link" to="/cart"><img src="images/cart.svg" alt="cart" /></Link></li>
                        </ul> */}
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Navbar;
